"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SUPPORTED_ERROR_CODES = void 0;
const SUPPORTED_ERROR_CODES = exports.SUPPORTED_ERROR_CODES = [0,
// fallback for unknown error codes
1,
// custom error code for WAF error page
401,
// Unauthorized access
404, 500];
